import axios from "axios";
const fetchModulesByCategory = async (category, setter) => {
    try {
        // const res = await axios.get(`/api/sportmodule/full/all`);
        const res = await axios.get(`/api/sportmodule/full/by-category`, {
            params: { category }
        });
        // res.data is an array of parent modules with `.modules` submodules

        // Flatten and filter submodules by category:
        const filteredSubmodules = res.data.flatMap(parentModule =>
            parentModule.modules
                .filter(sub => sub.category === category)
                .map(sub => ({
                    ...sub,
                    parent: parentModule // if you want parent info for later
                }))
        ).sort((a, b) => a.title.localeCompare(b.title));
        setter(filteredSubmodules);

    } catch (err) {
        console.error(`Fehler beim Laden der ${category} Module:`, err);
    }
};



export { fetchModulesByCategory };